/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placeholder_Post_TitleInputs */

const en_placeholder_post_title = /** @type {(inputs: Placeholder_Post_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Big News: New Collection Dropping Friday`)
};

const es_placeholder_post_title = /** @type {(inputs: Placeholder_Post_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ej. Gran Noticia: Nueva Colección el Viernes`)
};

const fr_placeholder_post_title = /** @type {(inputs: Placeholder_Post_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. Grande nouvelle : Nouvelle collection vendredi`)
};

const de_placeholder_post_title = /** @type {(inputs: Placeholder_Post_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. Große Neuigkeiten: Neue Kollektion am Freitag`)
};

const id_placeholder_post_title = /** @type {(inputs: Placeholder_Post_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mis. Berita Besar: Koleksi Baru Rilis Jumat`)
};

/** @type {(inputs: Placeholder_Post_TitleInputs) => LocalizedString} */
const ja_placeholder_post_title = en_placeholder_post_title;

/** @type {(inputs: Placeholder_Post_TitleInputs) => LocalizedString} */
const zh_placeholder_post_title = en_placeholder_post_title;

/** @type {(inputs: Placeholder_Post_TitleInputs) => LocalizedString} */
const ar_placeholder_post_title = en_placeholder_post_title;

/** @type {(inputs: Placeholder_Post_TitleInputs) => LocalizedString} */
const it_placeholder_post_title = en_placeholder_post_title;

/** @type {(inputs: Placeholder_Post_TitleInputs) => LocalizedString} */
const ru_placeholder_post_title = en_placeholder_post_title;

/** @type {(inputs: Placeholder_Post_TitleInputs) => LocalizedString} */
const pt_placeholder_post_title = en_placeholder_post_title;

/** @type {(inputs: Placeholder_Post_TitleInputs) => LocalizedString} */
const ko_placeholder_post_title = en_placeholder_post_title;

/**
* | output |
* | --- |
* | "e.g. Big News: New Collection Dropping Friday" |
*
* @param {Placeholder_Post_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const placeholder_post_title = /** @type {((inputs?: Placeholder_Post_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeholder_Post_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placeholder_post_title(inputs)
	if (locale === "es") return es_placeholder_post_title(inputs)
	if (locale === "fr") return fr_placeholder_post_title(inputs)
	if (locale === "de") return de_placeholder_post_title(inputs)
	if (locale === "ja") return ja_placeholder_post_title(inputs)
	if (locale === "zh") return zh_placeholder_post_title(inputs)
	if (locale === "ar") return ar_placeholder_post_title(inputs)
	if (locale === "id") return id_placeholder_post_title(inputs)
	if (locale === "it") return it_placeholder_post_title(inputs)
	if (locale === "ru") return ru_placeholder_post_title(inputs)
	if (locale === "pt") return pt_placeholder_post_title(inputs)
	return ko_placeholder_post_title(inputs)
});